<div class="dvb-rechnungs-revisionen row">
    <div class="col-md-7">
        <h2 data-translate="FAKTURA.RECHNUNGS_REVISIONEN"></h2>

        <dvb-rechnungen rechnungen="vm.rechnungen" mode="vm.mode" pre-selected-rechnung-id="vm.revisionId">
        </dvb-rechnungen>
    </div>
</div>
